// extracted by mini-css-extract-plugin
export default {"EmbedCount":"EmbedCount_EmbedCount__uzBYR","count":"EmbedCount_count__E3Dcu"};